export const COMPACT_CHART_HEIGHT = 'h-[210px]';
